export const SAVE_AFFECTATION_BUNDLE = 'SAGA/SAVE_AFFECTATION_BUNDLE';

export const saveAffectationBundle = (payload) => {
  return {
    type: SAVE_AFFECTATION_BUNDLE,
    payload,
  };
};
